import { css } from '@emotion/react';

export const Text1gMedium = css`
  font-family: 'Plus Jakarta Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
